export const colours = {
  light: {
    pageBackground: '#ddd',
    gridBackground: 'transparent',
    boxBackground: '#fff',
    boxText: '#444',
    boxTextSecondary: '#888',
    bigCallsNumber: '#888',
    bigCallsLabel: '#888',
    criticalBoxBackground: '#d32f2f',
    criticalBoxText: '#fff',
    criticalBoxLabelText: '#fbe3e4',
  },
  dark: {
    pageBackground: '#000',
    gridBackground: 'transparent',
    boxBackground: '#1e1e1e',
    boxText: '#bbb',
    boxTextSecondary: '#bbb',
    bigCallsNumber: '#bbb',
    bigCallsLabel: '#bbb',
    criticalBoxBackground: '#d32f2f',
    criticalBoxText: '#fff',
    criticalBoxLabelText: '#fbe3e4',
  },
};